<template>
  <div class="all_footer">
    <div class="all_footer_cen">
      <!--<div class="all_footer_cen_text">
        <span>隐私保护</span>
        <span>联系我们</span>
        <span>公司简介</span>
        <span>商务合作</span>
        <span>人才招聘</span>
      </div>-->
      <div class="all_footer_cen_txt">
        <p>@2005-2020北京全友云商电子商务有限公司 为您提供办公室整体解决方案</p>
        <p>Tel:400-700-2248</p>
        <p>E-mail:bgsxqy@vip.sina.com</p>
        <p>京ICP备15007099号</p>
        <p class="gongan">
          <img src="../imges/gongan.png" alt="">
          京公网安备 11011402010683号
        </p>
      </div>
      <div class="all_footer_cen_img">
        <img src="../assets/bouuom1.gif" alt />
        <img src="../assets/bouuom2.png" alt />
        <img src="../assets/bouuom3.gif" alt />
<!--        <img src="../assets/bouuom4.png" alt />-->
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Pagetail"
    }
</script>

<style scoped lang="less">
 @import "./css/Pagetail";
  .gongan{
    margin-bottom: 10px;
    img{
      vertical-align: top;
    }
  }
</style>



// WEBPACK FOOTER //
// src/assembly/Pagetail.vue